/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type {
  PermissionamentoSite,
  Unidade,
  Usuario,
} from '@infor/core/models/auth';

import { storage } from './storage';

export const COOKIES_TOKEN = 'infor.token_user';
export const LOCALSTORAGE_TOKEN_INFORCFC = 'infor.token_user';
export const LOCALSTORAGE_NIVEL_INFORCFC = 'infor.nivel_user';
export const LOCALSTORAGE_USER_INFORCFC = 'infor.user';
export const LOCALSTORAGE_UNIDADES_INFORCFC = 'infor.unidades';
export const LOCALSTORAGE_UNIDADE_CORRENTE_INFORCFC = 'infor.unidade_corrente';

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];

  if (!base64Url) {
    return {};
  }

  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export const setTokenLocalStorage = (token: string | null | undefined) => {
  const key = LOCALSTORAGE_TOKEN_INFORCFC;

  if (token) {
    storage.set(key, JSON.stringify(token));
  } else {
    storage.remove(key);
  }
};
export const setUsuarioLocalStorage = (usuario: Usuario | null) => {
  const key = LOCALSTORAGE_USER_INFORCFC;

  if (usuario) {
    storage.set(key, JSON.stringify(usuario));
  } else {
    storage.remove(key);
  }
};
export const setNivelUsuarioLocalStorage = (
  nivel: PermissionamentoSite[] | null
) => {
  if (nivel) {
    storage.set(LOCALSTORAGE_NIVEL_INFORCFC, JSON.stringify(nivel));
  } else {
    storage.remove(LOCALSTORAGE_NIVEL_INFORCFC);
  }
};

export const setUnidadesLocalStorage = (nivel: Unidade[] | null) => {
  if (nivel) {
    storage.set(LOCALSTORAGE_UNIDADES_INFORCFC, JSON.stringify(nivel));
  } else {
    storage.remove(LOCALSTORAGE_UNIDADES_INFORCFC);
  }
};
export const setUnidadeCorrenteLocalStorage = (nivel: Unidade | null) => {
  if (nivel) {
    storage.set(LOCALSTORAGE_UNIDADE_CORRENTE_INFORCFC, JSON.stringify(nivel));
  } else {
    storage.remove(LOCALSTORAGE_UNIDADE_CORRENTE_INFORCFC);
  }
};
